import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/uniform/cdf';
import __var_2__ from '@stdlib/stats/base/dists/uniform/ctor';
import __var_3__ from '@stdlib/stats/base/dists/uniform/entropy';
import __var_4__ from '@stdlib/stats/base/dists/uniform/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/uniform/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/uniform/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/uniform/mean';
import __var_8__ from '@stdlib/stats/base/dists/uniform/median';
import __var_9__ from '@stdlib/stats/base/dists/uniform/mgf';
import __var_10__ from '@stdlib/stats/base/dists/uniform/pdf';
import __var_11__ from '@stdlib/stats/base/dists/uniform/quantile';
import __var_12__ from '@stdlib/stats/base/dists/uniform/skewness';
import __var_13__ from '@stdlib/stats/base/dists/uniform/stdev';
import __var_14__ from '@stdlib/stats/base/dists/uniform/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace uniform
*/
var uniform = {};

/**
* @name cdf
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/cdf}
*/
setReadOnly( uniform, 'cdf', __var_1__);

/**
* @name Uniform
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/ctor}
*/
setReadOnly( uniform, 'Uniform', __var_2__);

/**
* @name entropy
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/entropy}
*/
setReadOnly( uniform, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/kurtosis}
*/
setReadOnly( uniform, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/logcdf}
*/
setReadOnly( uniform, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/logpdf}
*/
setReadOnly( uniform, 'logpdf', __var_6__);

/**
* @name mean
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/mean}
*/
setReadOnly( uniform, 'mean', __var_7__);

/**
* @name median
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/median}
*/
setReadOnly( uniform, 'median', __var_8__);

/**
* @name mgf
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/mgf}
*/
setReadOnly( uniform, 'mgf', __var_9__);

/**
* @name pdf
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/pdf}
*/
setReadOnly( uniform, 'pdf', __var_10__);

/**
* @name quantile
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/quantile}
*/
setReadOnly( uniform, 'quantile', __var_11__);

/**
* @name skewness
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/skewness}
*/
setReadOnly( uniform, 'skewness', __var_12__);

/**
* @name stdev
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/stdev}
*/
setReadOnly( uniform, 'stdev', __var_13__);

/**
* @name variance
* @memberof uniform
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/uniform/variance}
*/
setReadOnly( uniform, 'variance', __var_14__);


// EXPORTS //
export default uniform;

export { __var_1__ as cdf, __var_2__ as Uniform, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};